import { BackendUser, JobProps } from 'common/types'
import useApplyJob from 'hooks/use-apply-job/useApplyJob'
import { useJobsApi } from 'hooks/use-jobs-api/useJobsApi'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useUserApi } from 'hooks/use-user-api/useUserApi'
import { useEffect, useState } from 'react'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useLocation } from 'react-router-dom'

export const useMemberJobDetails = (jobId: string, _job?: JobProps) => {
  const {backendUser} = useAuth()
  const [userId, setUserId] = useState<string>()
  const [job, setJob] = useState<JobProps>(_job)
  const [loading, setLoading] = useState<boolean>(false)
  const [alreadyApplied, setAlreadyApplied] = useState<boolean>(false)
  const [user, setUser] = useState<BackendUser>()
  
  const { getJobById } = useJobsApi()
  const { getJobStatus } = useApplyJob()
  const { notify } = useNotification()
  const { fetchUser } = useUserApi()

  const { pathname } = useLocation()
  const openApplyModal = pathname.includes('/apply=true')
  const [isApplyModalOpen, setIsApplyModalOpen] = useState<boolean>(
    openApplyModal && backendUser && !alreadyApplied ? true : false
  )

  const fetchJob = async () => {
    setLoading(true)
    try {
      const jobResponse = await getJobById(jobId)
      let recruiter
      if (jobResponse?.userId) {
        recruiter = await fetchUser(jobResponse?.userId)
        setUser(recruiter)
      }

      setUserId(jobResponse?.userId)
      setJob(jobResponse)
      setLoading(false)
    } catch {
      notify('error', 'an error occoured')
      setLoading(false)
    }
  }

  useEffect(() => {
    !!jobId && fetchJob()
    if (jobId && backendUser?.id) {
      getJobStatus(jobId)
        .then(response => {
          setAlreadyApplied(!!response?.appliedDate)
        })
        .catch(() => {
          setAlreadyApplied(false)
        })
    }
  }, [jobId, userId])
  return { loading, job, alreadyApplied, setAlreadyApplied, user, fetchJob, isApplyModalOpen, setIsApplyModalOpen } as const
}
